import { Link } from '../../typedefs/external';
import { changeTypingStatus } from '../../actions';
import * as imagesLoaded from 'imagesloaded';
import * as React from 'react';
import { MessageWithMetadata, SettingsState, User } from '../../typedefs/store';
const debounce = require('lodash.debounce');

export interface BaseProps {
    convoAvatar: string;
    locationName: string;
    isMinimized: boolean;
    settings: SettingsState;
    showEndDialog: boolean;
    ending: boolean;
    ended: boolean;
    disableSending: boolean;
    numUnread: number;
    surveyCompleted: boolean;
    links: Link[];
    agent?: User;
    sendMessage: (text: string, tempId?: string) => void;
    toggleMinimized: () => void;
    requestClose: () => void;
    endConvo: () => void;
    removeConversation: (hide: boolean) => void;
    changeTypingStatus: (status: 'composing' | 'paused') => void;
    starters: string[];
    hasAnyVisitorMessages: boolean;
}

export interface BaseState {}

export default abstract class BaseConversationWrapper<
    Props extends BaseProps,
    State extends BaseState
> extends React.Component<Props, State> {
    bodyRef: HTMLDivElement | null;

    constructor(props: Props) {
        super(props);

        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.onMinimize = this.onMinimize.bind(this);
        this.onClose = this.onClose.bind(this);
        this.endConvo = this.endConvo.bind(this);
        this.handleSend = this.handleSend.bind(this);
    }

    /**
     * The only truly reliable way for this to work is to wrap the desired method in a setTimeout and a window.requestAnimationFrame
     * to ensure React's current call stack gets cleared before registering for the next frame's render.
     * https://stackoverflow.com/a/34999925/2076152
     */
    scrollToBottom() {
        setTimeout(() =>
            window.requestAnimationFrame(() => {
                if (!this.bodyRef) return;
                this.bodyRef.scrollTop = this.bodyRef.scrollHeight;
                imagesLoaded(this.bodyRef, () => {
                    if (!this.bodyRef) return;
                    this.bodyRef.scrollTop = this.bodyRef.scrollHeight;
                });
            }),
        );
    }

    onMinimize(e: React.MouseEvent<HTMLElement>): void {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggleMinimized();
    }

    onClose(e: React.MouseEvent<HTMLElement>): void {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.ended) {
            this.props.removeConversation(true);
        } else if (!this.props.hasAnyVisitorMessages) {
            // if there are no messages from the visitor, just end it without confirming
            this.props.endConvo();
            this.props.removeConversation(true);
        } else {
            this.props.requestClose();
        }
    }

    endConvo(e: React.MouseEvent<HTMLElement>): void {
        e.preventDefault();
        e.stopPropagation();
        this.props.endConvo();
    }

    handleSend(val: string, tempId?: string) {
        this.props.sendMessage(val, tempId);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/BaseConversationWrapper.tsx